// removed by extract-text-webpack-plugin
module.exports = {"Resume":"Resume__Resume___1t3sk","ResumeActive":"Resume__ResumeActive___GEzZj","ResumeHidden":"Resume__ResumeHidden___24EoK","expCol":"Resume__expCol___1WKL3","skillCol":"Resume__skillCol___3O7Ee","pdf":"Resume__pdf___3rgrH","pdfHidden":"Resume__pdfHidden___36u73","pdfText":"Resume__pdfText___2CHFH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Resume/Resume.css
// module id = 53
// module chunks = 0